var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M21 20h.5a.5.5 0 1 1 0 1h-19a.5.5 0 1 1 0-1H3V9a2 2 0 0 1 2-2h4V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5h2a2 2 0 0 1 2 2v8zm-4-9v9h3v-8a1 1 0 0 0-1-1h-2zm-1 9V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2h1a2 2 0 0 1 2 2v11h3zM6 20v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2h2V9a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v11h2zm1 0h2v-2H7v2zm-.5-10a.5.5 0 0 1 .5.5v1a.5.5 0 1 1-1 0v-1a.5.5 0 0 1 .5-.5zm3 0a.5.5 0 0 1 .5.5v1a.5.5 0 1 1-1 0v-1a.5.5 0 0 1 .5-.5zm-3 3a.5.5 0 0 1 .5.5v1a.5.5 0 1 1-1 0v-1a.5.5 0 0 1 .5-.5zm3 0a.5.5 0 0 1 .5.5v1a.5.5 0 1 1-1 0v-1a.5.5 0 0 1 .5-.5z" })
  );
});